/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_DisconnectInputs */

const cs_settings_calendar_disconnect = /** @type {(inputs: Settings_Calendar_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpojit`)
};

const en_settings_calendar_disconnect = /** @type {(inputs: Settings_Calendar_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Settings_Calendar_DisconnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_disconnect = /** @type {((inputs?: Settings_Calendar_DisconnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_DisconnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_disconnect(inputs)
	return cs_settings_calendar_disconnect(inputs)
});